import React, { useState } from "react";
import '../components/css/Header.css';
import TermsOfServiceModal from './TermsOfServiceModal';
import InstallApp from './InstallApp';

function Footer() {
  const [showTerms, setShowTerms] = useState(false);

  const handleShowTerms = () => setShowTerms(true);
  const handleCloseTerms = () => setShowTerms(false);

  return (
    <div className="main-footer">
      <div className="footer-content">
        <InstallApp />
        <p className="footer-text">
          &copy;{new Date().getFullYear()}{' '}
          <a href="https://www.dnctechsolutionsltd.com/" target="_blank" rel="noopener noreferrer">
            DNC Technology Solutions LTD
          </a>
          {' '}| All rights reserved |
          <button type="button" className="link terms-link" onClick={handleShowTerms}>Terms Of Service</button> | Privacy
        </p>
      </div>
      <TermsOfServiceModal show={showTerms} handleClose={handleCloseTerms} />
    </div>
  );
}

export default Footer;
